var map = {
	"./icon-close.svg": 6,
	"./icon-lizard.svg": 27,
	"./icon-paper.svg": 28,
	"./icon-rock.svg": 29,
	"./icon-scissors.svg": 30,
	"./icon-spock.svg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;